import { Box, Paper, Skeleton } from "@mui/material";
import React from "react";
import EntityDetailsPageHeaderSkeleton from "../EntityDetailsPageHeaderSkeleton";
import DocumentActionsSkeleton from "./DocumentActionsSkeleton.tsx";
import DocumentNavigationSkeleton from "./DocumentNavigationSkeleton.tsx";
import SectionConfigurationListSkeleton from "./SectionConfigurationListSkeleton.tsx";

const DueDiligencePageSkeleton = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 40px)",
      }}
    >
      <Box
        sx={{
          px: "24px",
          pt: "28px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 3,
          flexGrow: 1,
          overflow: "hidden",
          paddingBottom: "24px !important",
        }}
      >
        {/* Header */}
        <EntityDetailsPageHeaderSkeleton breadcumbsLength={2} hasFollowButton />

        {/* Research Insights */}
        <Paper
          sx={{
            borderRadius: ".5em",
            backgroundColor: "background.card.main",
            p: 0,
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {/* Main */}
          <Box
            sx={{
              pl: 2,
              borderRadius: ".5em .5em 0 0",
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                py: 1,
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <Skeleton variant="text" width={200} height={44} />
              <Skeleton variant="text" width={200} height={44} sx={{ mr: 2 }} />
            </Box>

            <Box
              sx={{ borderBottom: 1, borderColor: "divider", flexShrink: 0 }}
            />

            {/* Sections */}
            <Box sx={{ display: "flex", flexGrow: 1, overflow: "hidden" }}>
              <Box sx={{ flexShrink: 0 }}>
                <DocumentNavigationSkeleton />
              </Box>

              {/* Main Content - Sections & CAi */}
              <Box
                sx={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "row",
                  overflow: "hidden",
                }}
              >
                {/* Sections */}
                <Box
                  sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    borderRight: 1,
                    borderColor: "divider",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      px: "12px",
                      py: "15px",
                      flexGrow: 1,
                      overflowY: "auto",
                    }}
                  >
                    <SectionConfigurationListSkeleton />
                  </Box>
                </Box>

                {/* Section Panel */}
                <Box
                  sx={{
                    width: "73px",
                    flexShrink: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Box sx={{ padding: "6px", width: "100%" }}>
                    <Skeleton
                      variant="rectangular"
                      height="52px"
                      sx={{ borderRadius: 1 }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Paper>
        {/* </Box> */}
      </Box>

      {/* Actions — pinned to bottom */}
      <DocumentActionsSkeleton />
    </Box>
  );
};

export default DueDiligencePageSkeleton;
